import React from 'react';
import ZoomIcon from "../../../assets/icons/zoom.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from "./Linked";
import { ZOOM_APP_ID } from '../../../data/integration-app';

const Zoom = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <Link to="/integrations/zoom" className="int-col">
            {connectedVenues.some(data => parseInt(data.app_id) === ZOOM_APP_ID) && <Linked />}
            <div className="img">
                <img src={ZoomIcon} alt="Google Calendar" />
            </div>
            <div className="text">
                <h3>Zoom</h3>
                <p>
                Host and join meetings effortlessly with Zoom — video, chat, and collaboration made simple.
                </p>
            </div>
            </Link>
        </Col>
    );
}

export default Zoom;